// eslint-disable-next-line import/prefer-default-export
export const TALENTS_MODE = {
  filters: 'filters',
  search: 'search',
};
